export default __webpack_public_path__ + "static/media/MinnieHappy.c49866a4.jpg";